import { render, staticRenderFns } from "./loading-component-s2.vue?vue&type=template&id=5c9b3903&lang=html"
import script from "./loading-component-s2.vue?vue&type=script&lang=js"
export * from "./loading-component-s2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports